import styled from 'styled-components';

export const Editor = styled.div`
  padding: 1rem 1rem 2rem;
  box-sizing: border-box;
  color: ${p => p.theme.colors.onBackground};
  .menu-icon-picker { position: relative; flex-shrink: 0; }
  .menu-icon-picker summary {
    display: flex; align-items: center; justify-content: center; cursor: pointer;
    border: 1px solid ${p => p.theme.colors.onBackground}30; border-radius: 6px; padding: .5rem;
    color: ${p => p.theme.colors.primary}; list-style: none;
  }
  .menu-icon-picker summary::-webkit-details-marker { display: none; }
  .menu-icon-options {
    position: absolute; top: calc(100% + 4px); left: 0; z-index: 20;
    display: grid; grid-template-columns: repeat(4, 36px); gap: 4px; padding: .5rem;
    background: ${p => p.theme.colors.background}; border: 1px solid ${p => p.theme.colors.onBackground}30;
    border-radius: 8px; box-shadow: 0 4px 16px #0003;
  }
  .menu-icon-options button {
    display: flex; align-items: center; justify-content: center; width: 36px; height: 36px;
    background: transparent; border: 1px solid transparent; border-radius: 4px;
    color: ${p => p.theme.colors.onBackground}; cursor: pointer;
  }
  .menu-icon-options button[aria-pressed='true'], .menu-icon-options button:hover {
    background: ${p => p.theme.colors.primary}20; border-color: ${p => p.theme.colors.primary};
  }
  .menu-removed { margin-top: 1.5rem; border-top: 1px solid ${p => p.theme.colors.onBackground}30; padding-top: 1rem; }
  .menu-removed summary { cursor: pointer; }
  .menu-removed p { margin-top: .75rem; color: ${p => p.theme.colors.textLight}; }
  .menu-removed-row { display: flex; align-items: center; justify-content: space-between; gap: .5rem; }
  .menu-help { color: ${p => p.theme.colors.textLight}; margin: 0 0 1rem; }
  .menu-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: .6rem; margin-bottom: 1rem; }
  input, select {
    color: ${p => p.theme.colors.onBackground};
    background: ${p => p.theme.colors.background};
    border: 1px solid ${p => p.theme.colors.onBackground}30;
    border-radius: 6px; padding: .5rem; min-width: 0;
  }
  .menu-toolbar input { flex: 1; min-width: 120px; }
  .menu-list { min-height: 18px; }
  .menu-list .menu-list {
    margin-left: 22px; border-left: 1px solid ${p => p.theme.colors.primary}35; padding-left: 8px;
  }
  .menu-node { padding-top: 6px; }
  .menu-row {
    display: flex; align-items: center; gap: .6rem; min-height: 50px;
    border: 1px solid ${p => p.theme.colors.onBackground}30;
    border-radius: 8px; background: ${p => p.theme.colors.onBackground}08; padding: .5rem .6rem .5rem 0;
  }
  .menu-row > svg { flex-shrink: 0; }
  .menu-handle {
    align-self: stretch; display: flex; align-items: center; justify-content: center; width: 30px;
    flex-shrink: 0; margin: -.5rem 0; border: 0; border-radius: 7px 0 0 7px;
    color: ${p => p.theme.colors.onPrimary}; background: ${p => p.theme.colors.primary};
    cursor: grab; touch-action: none;
  }
  .menu-content { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: .4rem; }
  .menu-target {
    display: flex; align-items: center; flex-wrap: wrap; gap: .5rem; padding: 0;
  }
  .menu-target > select:last-of-type, .menu-target > input { flex: 1; min-width: 120px; }
  .menu-target-readonly { font-size: .85rem; color: ${p => p.theme.colors.textLight}; }
  .menu-target-type { color: ${p => p.theme.colors.primary}; font-weight: 500; }
  .menu-target-destination { min-width: 0; overflow-wrap: anywhere; }
  .menu-target > select:first-of-type { flex: 0 0 auto; min-width: 85px; }
  .menu-target > small { width: 100%; color: ${p => p.theme.colors.textLight}; }
  .menu-name { width: 100%; box-sizing: border-box; min-width: 0; overflow-wrap: anywhere; }
  .menu-actions { display: flex; align-items: center; gap: .25rem; }
  .menu-actions button {
    background: transparent; color: inherit; border: 0; border-radius: 4px; padding: .35rem; cursor: pointer;
  }
  .menu-actions button:disabled { opacity: .3; cursor: default; }
  .menu-actions button:hover:not(:disabled) { background: ${p => p.theme.colors.primary}20; }
  .menu-actions select { max-width: 150px; font-size: .85rem; }
  .menu-empty { font-size: .8rem; color: ${p => p.theme.colors.textLight}; padding: .4rem; pointer-events: none; }
  .sortable-ghost > .menu-row { opacity: .35; border-color: ${p => p.theme.colors.primary}; }
  .menu-error { color: ${p => p.theme.colors.negative}; margin-bottom: .75rem; }
  @media (max-width: 600px) {
    .menu-actions { flex-direction: column; gap: .1rem; }
    .menu-row { gap: .4rem; }
    .menu-target > select { max-width: 100%; }
    .menu-list .menu-list { margin-left: 10px; padding-left: 4px; }
  }
`;
